<template>
  <el-dialog
      v-model="dialogVisible"
      :title="formData.id?'修改用户':'新增用户'"
      top="20px"
      height="340px"
      width="700px"
      :close-on-click-modal="false"
      :append-to-body="true"
      :show-close="true"
      :before-close="handleClose">
    <div class="dialog-item1">
      <el-form autocomplete="off" :rules="rules" :model="formData" label-width="100px"  class="el-form-box" ref="ruleFormRef">
        <el-row>
          <el-col :span="12" :offset="12" :pull="12">
            <el-form-item label="角色：" prop="Role" >
              <el-select v-model="formData.Role" @change="changeTelToUsername">
                <el-option v-for="item of USERROLE" :key="item.ID" :value="item.ID" :label="item.Name"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="姓名：" prop="real_name"  >
              <el-input v-model="formData.real_name" placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证：" prop="id_card"  >
              <el-input v-model="formData.id_card" placeholder="请输入"/>
            </el-form-item>
          </el-col>
<!--          <el-col :span="12">-->
<!--            <el-form-item label="单位：" prop="company"  >-->
<!--              <el-input v-model="formData.company" placeholder="请输入"/>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--          <el-col :span="12">-->
<!--            <el-form-item label="职称：" prop="title"  >-->
<!--              <el-input v-model="formData.title" placeholder="请输入"/>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--          <el-col :span="12">-->
<!--            <el-form-item label="银行卡号：" prop="bank_card"  >-->
<!--              <el-input v-model="formData.bank_card" placeholder="请输入"/>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--          <el-col :span="12">-->
<!--            <el-form-item label="开户行：" prop="bank_name"  >-->
<!--              <el-input v-model="formData.bank_name" placeholder="请输入"/>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
          <el-col :span="12">
            <el-form-item label="电话：" prop="tel" >
              <el-input v-model="formData.tel" @blur="changeTelToUsername" @input="changeTelToUsername"  autocomplete="off" readonly onfocus="this.removeAttribute('readonly');"  placeholder="请输入"  name="tel"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用户名：" prop="username"  >
              <el-input v-model="formData.username" placeholder="注：专家用户名默认为专家手机号"/>
              <input  style="display: none">
              <input type="password"  style="display: none">
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="密码：" v-if="!formData.id"  prop="password"   >
              <el-input autocomplete="new-password" readonly onfocus="this.removeAttribute('readonly');"  type="password" name="password"  onclick="this.readonly = false" v-model="formData.password" placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="确认密码：" v-if="!formData.id"  prop="password_confirm"  >
              <el-input autocomplete="new-password"  type="password"  v-model="formData.password_confirm" placeholder="请输入"/>
            </el-form-item>
          </el-col>

<!--          <el-col :span="12">-->
<!--            <el-form-item label="授权：" prop="isActive" >-->
<!--              <el-switch-->
<!--                  v-model="formData.Status"-->
<!--                  class="ml-2"-->
<!--                  inline-prompt-->
<!--                  style="&#45;&#45;el-switch-on-color: #3f9dfd; &#45;&#45;el-switch-off-color: #a9aaab"-->
<!--                  active-text="启用"-->
<!--                  inactive-text="禁用"-->
<!--              />-->
<!--            </el-form-item>-->
<!--          </el-col>-->
          <el-col :span="24">
            <el-form-item label="备注：" prop="notes">
              <el-input type="textarea" v-model="formData.notes" placeholder="请输入"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="save(ruleFormRef)"
                   :loading = "loading"
        >确定</el-button
        >
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import {ref, defineProps, defineEmits, reactive,onMounted} from 'vue';
import {ElMessage} from "element-plus";
import {validateForm} from "@/utils/formValidate";
import {addAdminUser, updateAdminUser} from "@/api/userAdmin";
import {USERROLE} from "@/utils/commonSetting"
const emits = defineEmits(['close', 'success'])
const dialogVisible = ref(true)
const ruleFormRef = ref()
var formData = reactive({
  id:null,
  real_name:"", // 真实姓名
  username: null, //用户名
  // company:"", // 单位
  // title: null, //职称
  // bank_card:null, //银行卡号
  // bank_name:"",// 开户行
  tel:"", //电话
  id_card:"", //身份证
  password:"",// 密码
  password_confirm:null,// 密码
  Role:null,
  // Status:true,
  notes: null
})
const rules = ({
  real_name: [{required: true, message: '请输入账号使用人姓名', trigger: ['blur']}],
  username: [{required: true, message: '请输入登录账号', trigger: ['blur']}],
  // company: [{required: true, message: '请输入工作单位', trigger: ['blur']}],
  // title: [{required: true, message: '请输入职称', trigger: ['blur']}],
  // bank_card: [{required: true, message: '请输入银行卡号', trigger: ['blur']}],
  // bank_name: [{required: true, message: '请输入开户行', trigger: ['blur']}],
  tel: [
      {required: true, message: '请输入手机号', trigger: [ 'blur']},
    {pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: ['blur']}
  ],
  id_card: [
    // {required: true, message: '请输入身份证号', trigger: ['change', 'blur']},
    {pattern: /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])\d{3}[0-9Xx]$/, message: '请输入正确的身份证号', trigger: ['blur']}
  ],
  password: [{required: true, message: '请输入密码', trigger: ['blur']}],
  password_confirm: [{required: true, message: '请再次输入密码', trigger: ['blur']}],
  Role: [{required: true, message: '请设置账号角色', trigger: ['blur',"change"]}],
})
const loading = ref(false)


const props = defineProps({
  item: {
    default: {},
  }
})
// 开始
 onMounted(()=>{
   if(props.item && props.item.id){
     formData.real_name = props.item.real_name
     formData.username = props.item.username
     // formData.company = props.item.company
     // formData.title = props.item.title
     // formData.bank_card = props.item.bank_card
     // formData.bank_name = props.item.bank_name
     formData.tel = props.item.tel
     formData.id_card = props.item.id_card
     formData.Role = props.item.Role
     // formData.Status = props.item.Status===1,
     formData.notes = props.item.notes
     formData.id = props.item.id
   }

 })

const handleClose = () => {
  dialogVisible.value = false
  emits("close", true)
}
// 电话号码变为用户名称
const changeTelToUsername = ()=>{
  if(formData.Role===2 && formData.tel){
    formData.username = formData.tel
  }
}
// 保存
const save = async (ruleFormRef) => {
  // if(formData.Role===2){
  //   formData.username = formData.tel
  // }
  const isvalidate =await validateForm(ruleFormRef)
  if(!isvalidate){
    return
  }
  loading.value = true
  let res,messPre;
  const params = {
    ...formData,
    Status:formData.Status?1:0
  }
  if( formData.id){
    res = await updateAdminUser(params)
    loading.value = false
    messPre = '修改'
    if(res.success){
      ElMessage.success(messPre + "成功")
      emits("success", true)
    }
  }else{
    res = await addAdminUser(params)
    loading.value = false
    messPre = '创建'
    if(res.err_code===0){
      ElMessage.success(messPre + "成功")
      emits("success", true)
    }
  }



}
</script>

<style scoped>
.dialog-item1 {
  width: 100%;
  height: 300px;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
